import { AllSelection, Plugin } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';
import { PluginKey } from 'prosemirror-state';
export const highlightContentPluginKey = new PluginKey('highlightContent');
export class HighlightContentPlugin extends Plugin {
  constructor() {
    super({
      key: highlightContentPluginKey,
      state: {
        init: () => ({
          highlight: false
        }),
        apply(tr, value) {
          let data = tr.getMeta(this);
          if (data) {
            return data;
          }
          return value;
        }
      },
      props: {
        decorations(state) {
          let decorations = [];
          let allSelection = new AllSelection(state.doc);
          if (this.getState(state).highlight) {
            state.doc.nodesBetween(allSelection.from, allSelection.to, (node, position) => {
              if (node.isBlock) {
                decorations.push(Decoration.inline(position, position + node.nodeSize, {
                  class: 'embercom-prosemirror-composer-diffing-insertion'
                }));
              }
            });
          }
          return DecorationSet.create(state.doc, decorations);
        }
      }
    });
  }
}